
import { Entity, Field } from 'typegraph';
import GroupDiscountData from 'panels/bundleEntries/entities/GroupDiscountData';
import autobind from 'autobind-decorator';

class Price {
    @Field()
    public value: number;
}

class VolumeDiscount{
    @Field()
    public entryId: String;

    @Field({ entity: GroupDiscountData })
	public data: GroupDiscountData[];
}

export default class CartItem {

    @Field()
    public id: String;

    @Field()
    public quantity:number;

    @Field({entity: Price})
    public unitPrice:number

    @Field({entity: Price})
    public price:number

    @Field()
    public name: String;

    @Field({entity:VolumeDiscount})
    public discounter :VolumeDiscount;

    @Field()
    public discountApplied:Boolean

    @Field({entity: Price})
    public actualPrice:number

    @Field()
    public eligibleInstitutions:String

    
}





// WEBPACK FOOTER //
// ./src/panels/checkout/entities/CartItem.ts